import {TabIndexComponent} from './tab-index.component';

export const indexRoutes = [
    {
        path: 'index',
        component: TabIndexComponent
    }
];